/* Rose & Fire — play YouTube links in a lightbox instead of leaving the store.
   The link stays a normal link, so without JS it still opens YouTube. */
(function () {
  'use strict';

  function videoId(href) {
    var m = String(href).match(/(?:youtube\.com\/watch\?(?:.*&)?v=|youtu\.be\/|youtube\.com\/shorts\/)([\w-]{11})/);
    return m ? m[1] : null;
  }

  var box = null, frame = null, lastFocus = null;

  function build() {
    box = document.createElement('div');
    box.className = 'rf-vbox';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', 'Video');
    box.hidden = true;
    box.innerHTML = '<div class="rf-vbox__in"><button type="button" class="rf-vbox__x" aria-label="Close video">&times;</button>'
      + '<div class="rf-vbox__f"></div></div>';
    document.querySelector('.rfx').appendChild(box);
    frame = box.querySelector('.rf-vbox__f');
    box.addEventListener('click', function (e) {
      if (e.target === box || e.target.closest('.rf-vbox__x')) close();
    });
  }

  function open(id) {
    if (!box) build();
    lastFocus = document.activeElement;
    frame.innerHTML = '<iframe src="https://www.youtube-nocookie.com/embed/' + id
      + '?autoplay=1&rel=0&playsinline=1" title="Video" allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowfullscreen></iframe>';
    box.hidden = false;
    document.body.style.overflow = 'hidden';
    box.querySelector('.rf-vbox__x').focus();
  }

  function close() {
    if (!box || box.hidden) return;
    frame.innerHTML = '';                 // stops playback
    box.hidden = true;
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.rfx a[href*="youtube.com"], .rfx a[href*="youtu.be"]');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey) return;
    var id = videoId(a.href);
    if (!id) return;
    e.preventDefault();
    open(id);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
})();
